var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VbDemo',[_c('VbCard',{attrs:{"dashed":"","no-padding":""}},[_c('Signup',{staticStyle:{"width":"500px"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }